import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { useAppDispatch } from '@/store/store.hooks';
import { startRealtime, stopRealtime } from '@/lib/socket/socket.manager';
import { sessionBootstrap } from '@/lib/session/session.bootstrap';
import sessionWatch from '@/lib/session/session.watch';
import stepUpRegister from '@/lib/beauth/step.up.register';
import { router } from '@/router/Router';

const App: React.FC = () => {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        const unregister = stepUpRegister();
        const unwatch = sessionWatch(dispatch);
        void sessionBootstrap(dispatch);
        startRealtime(dispatch);
        return () => {
            stopRealtime();
            unwatch();
            unregister();
        };
    }, [dispatch]);

    return <RouterProvider router={router} />;
};

export default App;
